import { loading } from 'State/actions';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getAllergenAction = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.ALLERGEN_FIELDS_LOADING, true));

      const response = await MPWWebApi.getGeneric('Allergen');

      dispatch({
        type: types.GET_ALLERGEN,
        payload: response,
      });
    } catch (ex) {
      dispatch({
        type: types.GET_ALLERGEN_ERROR,
        payload: ex.response,
      });
    } finally {
      dispatch(loading(types.ALLERGEN_FIELDS_LOADING, false));
    }
  };
};

export const getTeachersAction = site => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.ALLERGEN_FIELDS_LOADING, true));

      const response = await MPWWebApi.getGeneric(`student/teacher/${site}`);

      dispatch({
        type: types.GET_ALLERGEN_TEACHERS,
        payload: response,
      });
    } catch (ex) {
      dispatch({
        type: types.GET_ALLERGEN_REPORT_ERROR,
        payload: ex.response,
      });
    } finally {
      dispatch(loading(types.ALLERGEN_FIELDS_LOADING, false));
    }
  };
};

export const getAllergenReportAction = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.ALLERGEN_REPORT_LOAD, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        'reports/Allergen',
        data
      );

      dispatch({
        type: types.GET_ALLERGEN_REPORT,
        payload: response,
      });
    } catch (ex) {
      dispatch({
        type: types.GET_ALLERGEN_REPORT_ERROR,
        payload: ex.response.data.Errors,
      });
    } finally {
      dispatch(loading(types.ALLERGEN_REPORT_LOAD, false));
    }
  };
};

export const getAllergenReportExcel = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.ALLERGEN_REPORT_LOAD, true));

      await MPWWebApi.postDownloadFile(
        'reports/Allergen',
        'StudentAllergiesReport',
        data,
        FileDownloadTypes.ExcelOpenXML
      );
    } catch (ex) {
      dispatch({
        type: types.GET_ALLERGEN_REPORT_ERROR,
        payload: ex.response.data.Errors,
      });
    } finally {
      dispatch(loading(types.ALLERGEN_REPORT_LOAD, false));
    }
  };
};

export const loadingReportAction = status => {
  return {
    type: types.ALLERGEN_REPORT_LOAD,
    payload: status,
  };
};

export const clearReportDataAction = () => {
  return {
    type: types.CLEAR_REPORT_DATA,
  };
};



// WEBPACK FOOTER //
// ./src/pages/studentallergies/state/actions.js